/**
 *  Removes any SVGs used to underline content being read.
 * @param {Document} frameDocument - current iframe document
 */
const removeSvg = (frameDocument) => {
  frameDocument?.querySelectorAll('.tts-underline')?.forEach((svgElement) => {
    svgElement.parentElement.removeChild(svgElement);
  });
};

export default removeSvg;
